module.exports = __webpack_public_path__ + "img/2021-07.80b300d4.jpg";